export const DEX_DEV_RATES_WIDGET_TYPE_ID = 'DexDevRatesWidget';
